import { c as _c } from "react-compiler-runtime";
import { cva, type VariantProps } from "class-variance-authority";
import * as React from "react";
import { cn } from "@/core/utils";
import Text from "../Text/Text";
type OverlayMode = "fixed" | "contained";
const panelVariants = cva("border-border bg-card text-card-foreground shadow-elevated relative w-full border", {
  variants: {
    size: {
      sm: "max-w-sm",
      md: "max-w-md",
      lg: "max-w-lg"
    },
    radius: {
      sm: "rounded-sm",
      md: "rounded-md",
      lg: "rounded-lg"
    }
  },
  defaultVariants: {
    size: "md",
    radius: "lg"
  }
});
export type OverlayProps = React.HTMLAttributes<HTMLDivElement> & VariantProps<typeof panelVariants> & {
  isOpen?: boolean;
  title?: string;
  actions?: React.ReactNode;
  mode?: OverlayMode;
  onClose?: () => void;
};
export function Overlay(t0) {
  const $ = _c(33);
  let actions;
  let children;
  let className;
  let onClose;
  let props;
  let radius;
  let size;
  let t1;
  let t2;
  let title;
  if ($[0] !== t0) {
    ({
      className,
      size,
      radius,
      isOpen: t1,
      title,
      actions,
      mode: t2,
      onClose,
      children,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = actions;
    $[2] = children;
    $[3] = className;
    $[4] = onClose;
    $[5] = props;
    $[6] = radius;
    $[7] = size;
    $[8] = t1;
    $[9] = t2;
    $[10] = title;
  } else {
    actions = $[1];
    children = $[2];
    className = $[3];
    onClose = $[4];
    props = $[5];
    radius = $[6];
    size = $[7];
    t1 = $[8];
    t2 = $[9];
    title = $[10];
  }
  const isOpen = t1 === undefined ? false : t1;
  const mode = t2 === undefined ? "fixed" : t2;
  if (!isOpen) {
    return null;
  }
  const containerClasses = mode === "contained" ? "absolute inset-0" : "fixed inset-0";
  let t3;
  if ($[11] !== containerClasses) {
    t3 = cn("bg-overlay/80 z-50 flex items-center justify-center p-4 backdrop-blur-sm", containerClasses);
    $[11] = containerClasses;
    $[12] = t3;
  } else {
    t3 = $[12];
  }
  let t4;
  if ($[13] !== className || $[14] !== radius || $[15] !== size) {
    t4 = cn("p-6", panelVariants({
      size,
      radius,
      className
    }));
    $[13] = className;
    $[14] = radius;
    $[15] = size;
    $[16] = t4;
  } else {
    t4 = $[16];
  }
  let t5;
  if ($[17] !== title) {
    t5 = title ? <div className="mb-4"><Text component="h3" text={title} variant="heading-lg" /></div> : null;
    $[17] = title;
    $[18] = t5;
  } else {
    t5 = $[18];
  }
  let t6;
  if ($[19] !== children) {
    t6 = <div>{children}</div>;
    $[19] = children;
    $[20] = t6;
  } else {
    t6 = $[20];
  }
  let t7;
  if ($[21] !== actions) {
    t7 = actions ? <div className="mt-6 flex gap-3">{actions}</div> : null;
    $[21] = actions;
    $[22] = t7;
  } else {
    t7 = $[22];
  }
  let t8;
  if ($[23] !== props || $[24] !== t4 || $[25] !== t5 || $[26] !== t6 || $[27] !== t7) {
    t8 = <div aria-modal="true" className={t4} role="dialog" onClick={_temp} {...props}>{t5}{t6}{t7}</div>;
    $[23] = props;
    $[24] = t4;
    $[25] = t5;
    $[26] = t6;
    $[27] = t7;
    $[28] = t8;
  } else {
    t8 = $[28];
  }
  let t9;
  if ($[29] !== onClose || $[30] !== t3 || $[31] !== t8) {
    t9 = <div className={t3} onClick={onClose}>{t8}</div>;
    $[29] = onClose;
    $[30] = t3;
    $[31] = t8;
    $[32] = t9;
  } else {
    t9 = $[32];
  }
  return t9;
}
function _temp(event) {
  return event.stopPropagation();
}